/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface IOnlineEventState {
  eventId: string;
  provider: 'google' | 'microsoft' | 'zoom';
  name: string;
  startDateTime: string;
  endDateTime: string;
  webLink: string;
}
interface IEventResults {
  askToConnectCalendar: boolean;
  isGoogleCalendarConnected: boolean;
  isMicrosoftCalendarConnected: boolean;
  isZoomMeetingsConnected: boolean;
  events: IOnlineEventState[];
}
interface EventsState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  results: null | IEventResults;
  error: string | null;
}
const initialState: EventsState = {
  status: 'idle',
  results: null,
  error: null,
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setEventsStatus: (
      state,
      action: PayloadAction<'idle' | 'loading' | 'succeeded' | 'failed'>
    ) => {
      state.status = action.payload;
    },
    setEventsResults: (state, action: PayloadAction<IEventResults>) => {
      state.results = action.payload;
    },
    setEventsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setEventsStatus,
  setEventsResults,
  setEventsError,
} = eventsSlice.actions;

export default eventsSlice.reducer;
